









import { Component, Prop, Vue } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class BlocoDeCodigo extends Vue {
	@Prop({ type: String, required: true }) conteudo!: string

	copiar() {
		navigator.clipboard.writeText(this.conteudo)
		AlertModule.setSuccess('Copiado para a área de transferência')
	}
}
